var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vcon"},[_c('b-spinner',{attrs:{"label":_vm.label,"variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }